import {useContext} from "react";
import { TableContext } from "./TableContext";

const useTableData = () => {
    return useContext(TableContext);
}

export default useTableData;